import Swiper from 'swiper';
import 'swiper/css';

export const initSlider = (slider, index, element,
                           gap = 12,
                           gapSM = 12,
                           gapMD = 12,
                           gapLG = 12,
                           gapXL = 12,
                           slidesPerView = 1.5,
                           slidesSM = 2.5,
                           slidesMD = 3.5,
                           slidesLG = 4.5,
                           slidesXL = 5.5) => {

    if(slider.dataset.gap) {
        gap = slider.dataset.gap;
    }
    if(slider.dataset.slidexs) {
        slidesPerView = parseFloat(slider.dataset.slidexs);
    }

    if(slider.dataset.slidessm) {
        slidesSM = slider.dataset.slidessm;
    }
    if(slider.dataset.gapsm) {
        gapSM = slider.dataset.gapsm;
    }

    if(slider.dataset.slidesmd) {
        slidesMD = slider.dataset.slidesmd;
    }
    if(slider.dataset.gapmd) {
        gapMD = slider.dataset.gapmd;
    }

    if(slider.dataset.slideslg) {
        slidesLG = slider.dataset.slideslg;
    }
    if(slider.dataset.gaplg) {
        gapLG = slider.dataset.gaplg;
    }

    if(slider.dataset.slidesxl) {
        slidesXL = slider.dataset.slidesxl === '0' ? '5.5' : slider.dataset.slidesxl;
    }
    if(slider.dataset.gapxl) {
        gapXL = slider.dataset.gapxl;
    }

    const swiper = new Swiper(slider, {
        slidesPerView: slidesPerView,
        spaceBetween: gap,
        navigation: {
            nextEl: slider.parentElement.querySelector(".js-product-slider-next"),
            prevEl:  slider.parentElement.querySelector(".js-product-slider-prev"),
        },
        pagination: {
            el:  slider.parentElement.querySelector(".js-product-slider-pagination"),
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: slidesSM,
                spaceBetween: gapSM,
            },
            768: {
                slidesPerView: slidesMD,
                spaceBetween: gapMD,
            },
            1024: {
                slidesPerView: slidesLG,
                spaceBetween: gapLG,
            },
            1600: {
                slidesPerView: slidesXL,
                spaceBetween: gapXL,
            }
        },
    });

};

[...document.querySelectorAll('.js-slider')].map(initSlider);
